import { useEffect } from "react";
import styles from './Terms.module.css';

const Terms = () => {
	useEffect(() => {
        document.title = 'Terms';
    }, []);

	return (
		<div className={styles.container}>
			<div className={styles.subheader}>
				Updates to this Agreement
			</div>
			<div className={styles.paragraph}>
				We may revise this Agreement at any time. By your continued use of the Sites, you
				agree to be bound by future revisions. If we make a material change to this Agreement
				we may post advance notice on the Site, and if you are a Fundraiser or Donor with an
				active account, we may also notify you of any such changes via the email we have on
				file for you, or otherwise as required by law, and request your consent to such changes.
			</div>
			<div className={styles.subheader}>
				Privacy
			</div>
			<div className={styles.paragraph}>
				We are committed to protecting the privacy of any personal information you may provide
				to us when you use the Sites. This Agreement includes and incorporates by reference
				PYC Giving Foundation’s (PYCGF’s) Privacy Policy. By accepting the terms of this
				Agreement, you agree to abide by the terms of our Privacy Policy.
			</div>
			<div className={styles.subheader}>
				Usage of Our Sites and Services
			</div>
			<div className={styles.paragraph}>
				To use the Sites, including our social media platforms such as Facebook and Twitter,
				you represent that:
				<ol>
					<li>
						You are a U.S. resident physically located in the United States;
					</li>
					<li>
						You are at least 18 years old (or at least 13 years old and have the permission of
						a parent or legal guardian) and are lawfully able to enter into contracts;
					</li>
					<li>
						You agree to comply with this legally-binding Agreement; and
					</li>
					<li>
						You have all necessary rights and authority to use the Sites and PYCGF’s
						services, including (but not limited to) the right to upload, post, and/or otherwise
						provide to PYCGF &quot;User Content&quot; (defined as any text, images, or other digital
						content posted or provided by a user), and you have received all necessary for
						any User Content you provide.
					</li>
				</ol>
				If you do not have the necessary authority, or if you do not agree with any of the Terms
				in this Agreement, then you may not use the Sites. Any use of the Sites in violation of
				this Agreement is prohibited.
			</div>
			<div className={styles.subheader}>
				Important Note for Fundraisers
			</div>
			<div className={styles.paragraph}>
				As specified below, you ensure that any User Content you post on the Site:
				<ol>
					<li>
						Does not violate any federal, state, or local laws, regulations, or ordinances; and
					</li>
					<li>
						Does not contain pictures of or information about any minor without express
						written permission from the minor’s parent(s) or legal guardian(s).
					</li>
				</ol>
			</div>
			<div className={styles.subheader}>
				Services
			</div>
			<div className={styles.italicParagraph}>
				This section outlines the services that our Sites provide, and that are covered in these Terms.
			</div>
			<div className={styles.paragraph}>
				PYC Giving Foundation (“PYCGF”) is a public charity that solicits and facilitates
				donations from interested funders (referred to in these Terms as Donors) to Fundraisers
				(as defined below) seeking resources for charitable purposes. The Sites provide you
				access to information, data, files, and services related to PYCGF and its work including
				text, photographs, audio and video, graphics, software, logos, images, and other
				content and are subject to these Terms. Collectively, this content and User Content,
				along with any additional content posted or otherwise shared by PYCGF, are considered
				“Site Content” for the purposes of this Agreement. Any new User Content or Site
				Content added to the Sites (including all revisions, modifications, and enhancements to
				the Sites) will be covered by this Agreement effective upon the date of each addition.
			</div>
			<div className={styles.paragraph}>
				PYCGF is a public charity that solicits and facilitates donations from Donors to
				Fundraisers, but PYCGF is not a party to any agreement between any users. PYCGF is
				not a broker, agent, financial institution, creditor, or insurer for any user, and we don’t
				intend to provide financial, legal, tax, or other professional advice. Before making any
				decision regarding any donations, you should consult your financial, legal, tax, or other
				professional advisor as appropriate. You acknowledge that you access any Site Content
				by using the Site at your own risk.
			</div>
			<div className={styles.subheader}>
				Our Proprietary Materials
			</div>
			<div className={styles.italicParagraph}>
				This section provides information on what you can and can’t do with the Content found on our Site.
			</div>
			<div className={styles.paragraph}>
				PYCGF owns (or is licensed to use) the Sites, and the trademarks, service marks, and
				logos within it. These are protected by copyright, patent, trademark, and other
				intellectual property laws of the United States and other countries, as well as by
				international treaties and conventions.
			</div>
			<div className={styles.paragraph}>
				The Site, including its Site Content, may be used solely for your personal, informational,
				and non-commercial purposes. You can use our logo and other Site Content found
				on www.giverist.com in alignment with our brand policies. Outside of the Site Content
				found on www.giverist.com, you may not modify, copy, scrape, augment, delete,
				distribute, transmit, reproduce, publish, license, monetize, create derivative works from,
				transfer, or sell the Site Content you access through our Sites, except that you may view
				the Site and its Site Content in their present form. All other uses of the Site and Site
				Content require prior written consent from PYCGF. All rights to this Site Content are
				reserved by PYCGF or their respective owners, except where noted otherwise.
			</div>
			<div className={styles.paragraph}>
				We grant you limited rights to link to our Sites. By publishing a link to our Sites on your
				website, you warrant that the content of your website is appropriate and consistent with
				the stated purposes of the Sites and PYCGF. If this is not the case, you may not link to
				any Site. PYCGF reserves the right to rescind the right to link to its Sites at its sole
				discretion.
			</div>
			<div className={styles.subheader}>
				Use and Restrictions
			</div>
			<div className={styles.italicParagraph}>
				This section outlines the things that you can and can’t do when accessing or using our
				Sites, regardless of whether you’ve set up an account.
			</div>
			<div className={styles.paragraph}>
				You are responsible for using the Sites according to the Terms, and you are responsible
				for your activity on the Sites and for all activity that occurs under your account, should
				you choose to create one.
			</div>
			<div className={styles.paragraph}>
				If you create an account, you agree to:
				<ol>
					<li>
						Only provide information that is true and accurate (for example, you must provide
						your full legal name and, where applicable, your organization’s full legal name),
						and to promptly update that information in the event of any change;
					</li>
					<li>
						Maintain the confidentiality of your user name and password;
					</li>
					<li>
						Notify PYCGF if you know of or suspect a security breach of our Sites;
					</li>
					<li>
						Maintain only one account; and
					</li>
					<li>
						Use the Sites in compliance with all applicable laws, regulations, and ordinances.
					</li>
				</ol>
			</div>
			<div className={styles.paragraph}>
				You will not use the Sites to:
				<ol>
					<li>
						Engage in any behavior that is unlawful, tortious, intrusive, libelous, or
						defamatory; otherwise harm, threaten, abuse, disrespect or harass other users or
						our staff, or share User Content that is unlawful, vulgar, obscene, libelous,
						invasive of another’s privacy, disrespectful, hateful, or racially, ethnically, or
						otherwise objectionable;
					</li>
					<li>
						Impersonate another user or provide false information;
					</li>
					<li>
						Forge headers or otherwise manipulate identifiers in order to disguise the origin
						of any material transmitted through the Sites;
					</li>
					<li>
						Damage or interfere, or attempt to damage or interfere with the proper working of
						the Site or surreptitiously intercept any system, data, or personal information
						from the Site. This includes transmitting any material to the Sites that contains
						viruses, worms, files, programs, or other computer code designed to disable,
						interrupt, destroy, redirect, monitor another’s usage, or to limit or otherwise inhibit
						the functionality of any computer software, hardware, or telecommunications
						equipment;
					</li>
					<li>
						Use any scraper, crawler, spider, robot, or other automated means of any kind to
						access or copy data on the Site; deep-link to any feature or content on the Site;
						or, bypass our robot exclusion headers or other measures we may use to prevent
						or restrict access to the Site;
					</li>
					<li>
						Intentionally or unintentionally violate any applicable law;
					</li>
					<li>
						Engage in any fraudulent or unlawful activity, or any harmful, false, or deceptive practice;
					</li>
					<li>
						Resell, decompile, reverse engineer, disassemble, or otherwise convert the
						software underlying the Sites; monitor the Site’s availability, performance, or
						functionality for any competitive purpose; or develop a competing product or
						service using the Site Content available on the Site;
					</li>
					<li>
						Contact, advertise to, solicit, or sell to any person featured on the Site; or to
						otherwise use contact information provided on the Site for unauthorized purposes; or
					</li>
					<li>
						Use the Site for any commercial purpose not expressly approved by PYCGF.
					</li>
				</ol>
			</div>
			<div className={styles.paragraph}>
				Any unauthorized use of the Site or its Site Content may subject you to civil or criminal
				liability and may result in PYCGF terminating your access and/or use of the Site.
				PYCGF may investigate any activity that may involve such violations and may
				cooperate with law enforcement authorities in prosecuting any user who is involved in
				such violations.
			</div>
			<div className={styles.paragraph}>
				From time to time, we may, in response to concerns of unauthorized use of funding or
				donations, place a hold on an account, restrict donations, reverse transactions, redirect
				donations, or take similar actions to protect our interests and those of our users.
			</div>
			<div className={styles.subheader}>
				PYCGF reserves the right to exclude any user from the Site, including any
				Fundraiser or Donor, at its sole discretion. PYCGF does not have the obligation to
				monitor comments on the Site. PYCGF has the right to remove any Site Content
				on our Site.
			</div>
			<div className={styles.paragraph}>
				You recognize that if you breach these Terms, it may cause PYCGF and others to suffer
				irreparable loss, damage, and harm in an amount not easily ascertained. You therefore
				agree that PYCGF may immediately seek an injunction against you to stop your
				distribution, display, or copying of any Site content, and you waive any objection to the
				scope of such an action.
			</div>
			<div className={styles.subheader}>
				User-Generated Content
			</div>
			<div className={styles.italicParagraph}>
				As a public charity, we rely on user-generated content to run our website. This section
				covers the rules you need to abide by and the permission you give us when submitting
				any content to PYCGF.
			</div>
			<div className={styles.paragraph}>
				When you submit User Content to PYCGF, you represent that you have all the
				necessary rights, licenses, waivers and releases to post, email, or upload the User
				Content. You’re also responsible for the legality, reliability, appropriateness, relevance,
				originality, and copyright of any such User Content.
			</div>
			<div className={styles.paragraph}>
				How PYCGF may use User Content, which includes Fundraiser Content: While you
				retain ownership of the works you create or submit to PYCGF, you grant us and others
				working on our behalf a perpetual, irrevocable, worldwide, non-exclusive, fully-paid, and
				fully-sublicensable license to use any Fundraiser Content (defined as: your name,
				school name, city, state, project essay, thank-you package, impact letter, donation
				comments, and photos), and any portion thereof, in furtherance of PYCGF’s purposes
				and activities and to promote PYCGF, the Sites, and its programs. This includes the
				right to copy; publish; display; create derivative works, in marketing efforts on third-party
				platforms, such as but not limited to, Facebook and Google, and make other uses of the
				Fundraiser Content, including but not limited to User Content posted or provided to our
				Sites, and license others to do the same, for PYCGF’s purposes, whether or not your
				fundraiser is funded.
			</div>
			<div className={styles.paragraph}>
				How PYCGF partners (who fund your project) may use User Content, which includes
				Fundraiser Content: Additionally, you grant a perpetual, irrevocable, worldwide, non-
				exclusive, fully-paid, and fully-sublicensable license to any PYCGF partners, who
				contribute funding to your project, to use any Fundraiser Content internally and
				externally, included but not limited to, in their marketing efforts on third-party platforms,
				such as but not limited to, Facebook and Google.
			</div>
			<div className={styles.paragraph}>
				Any questions, suggestions, ideas, feedback, or other information about the Site or User
				Content provided by you to PYCGF are non-confidential. PYCGF is entitled to
				unrestricted use and dissemination of these submissions for any purpose—commercial
				or otherwise—without acknowledgment or compensation to you.
			</div>
			<div className={styles.paragraph}>
				PYCGF may preserve any User Content and may also disclose User Content if required
				to do so by law or in the good-faith belief that such preservation or disclosure is
				reasonably necessary to comply with legal process, applicable laws, or government
				requests; to enforce these Terms; to respond to claims that any User Content violates
				the rights of third parties; or to protect the rights, property, or personal safety of PYCGF,
				its users, or the public.
			</div>
			<div className={styles.paragraph}>
				If any User Content you upload or post to the Site contains your name, image, or
				likeness, you hereby release and hold harmless PYCGF and its contractors and
				employees from all claims of invasion of privacy, publicity, libel, or any other claims
				made by you or any successor to such claim in connection with the User Content you
				provided.
			</div>
			<div className={styles.subheader}>
				Copyright Issues
			</div>
			<div className={styles.italicParagraph}>
				This section describes the process you agree to should there be any copyright concerns
				regarding Content on our Sites.
			</div>
			<div className={styles.paragraph}>
				We will process and investigate clear notices of alleged infringement and will take
				appropriate actions under the Digital Millennium Copyright Act (“DMCA”) and other
				applicable intellectual property laws with respect to any alleged or actual infringement.
			</div>
			<div className={styles.paragraph}>
				Our designated agent for notice of alleged copyright infringement is:
			</div>
			<div className={styles.paragraph}>
				PYC Giving Foundation
				<br/>
				<a href="mailto:hello@pycfoundation.org">
					hello@pycfoundation.org
				</a>
			</div>
			<div className={styles.subheader}>
				Fundraiser Terms
			</div>
			<div className={styles.italicParagraph}>
				This section outlines what’s additionally required of you when creating a Fundraiser
				account on PYCGF.
			</div>
			<div className={styles.border}/>
			<div className={styles.subheader}>
				Fundraiser Accounts
			</div>
			<div className={styles.paragraph}>
				By registering for a Fundraiser account with PYCGF, you acknowledge and agree that:
				<ol>
					<li>
						You are a “Fundraiser,” and meet all of the following criteria:
						<ul>
							<li>
								You are a U.S. resident physically located in the United States;
							</li>
							<li>
								You are at least 18 years old (or at least 13 years old and have the
								permission of a parent or legal guardian) and are lawfully able to enter into
								contracts;
							</li>
							<li>
								You are requesting funding for an exempt charitable purpose as defined in
								Internal Revenue Code section 501(c)(3) (see
								https://www.irs.gov/charities-non-profits/charitable-purposes)
							</li>
						</ul>
					</li>
					<li>
						No local law, regulation, or institutional policy prohibits your use of the Site, and
						you have obtained all necessary authorization from your organization to enter
						into this Agreement.
					</li>
					<li>
						From time to time, PYCGF may contact you through email or by phone (including
						automated calls and text messages) about your account, project, or use of the
						Sites. Even if you “opt out” of a correspondence, you’re still responsible to be
						aware of any information or updates we send about your account.
					</li>
				</ol>
			</div>
			<div className={styles.border}/>
			<div className={styles.subheader}>
				Fundraising Submissions
			</div>
			<div className={styles.paragraph}>
				PYCGF has sole discretion to approve fundraisers submitted by Fundraisers. By
				creating a fundraiser on our Site, you acknowledge and agree that:
				<ol>
					<li>
						The activity you propose is legal, and you have the necessary permissions from
						your organization to utilize the funds raised;
					</li>
					<li>
						You, your friends or family members will not financially benefit from the project;
					</li>
					<li>
						You have the right to upload all data or information that you provide on behalf of
						yourself pr your organization. You are solely responsible for obtaining these
						rights, permissions, and authorizations before submitting this User Content to
						PYCGF;
					</li>
					<li>
						PYCGF is not required to treat any submission as confidential, and reserves the
						right to approve fundraisers at its sole discretion.
					</li>
				</ol>
			</div>
			<div className={styles.border}/>
			<div className={styles.subheader}>
				Thank-You Responsibilities
			</div>
			<div className={styles.paragraph}>
				Once a fundraiser funded and implemented (i.e., the funds are put to use for their stated
				charitable purpose), Fundraisers are required to complete a thank-you update
				(“Update”). The Update consists of an impact update and digital photos (either of the
				project in action or of hand-written thank-you notes from beneficiaries), and physical
				thank-you notes from beneficiaries. You understand that the promptness and
				thoroughness with which you complete the Update may affect how many fundraisers
				you are allowed to submit in the future.
			</div>
			<div className={styles.subheader}>
				Additional Terms for Donors
			</div>
			<div className={styles.italicParagraph}>
				There are a few ways to donate through PYCGF. You can give directly to a Fundraiser,
				or to PYCGF. This section defines what you agree to when placing such donations.
			</div>
			<div className={styles.border}/>
			<div className={styles.subheader}>
				Donations to Projects
			</div>
			<div className={styles.paragraph}>
				Each donation made to PYCGF goes directly to fund the fundraiser or Fundraiser for
				which it was given. Donors are encouraged to allocate 15% of their donation towards
				PYCGF operations but can remove or reduce this allocation at time of donation.
			</div>
			<div className={styles.paragraph}>
				We cannot offer refunds on donations. If the fundraiser you donated to expires or
				otherwise doesn’t move forward before it is fully funded, or if we determine, in our sole
				discretion, that a fundraiser is for an ineligible purpose, we will redirect your donation to
				an eligible fundraiser of our choosing and shall notify you of the change.
			</div>
			<div className={styles.border}/>
			<div className={styles.subheader}>
				Terms of Donating
			</div>
			<div className={styles.paragraph}>
				PYCGF is a 501(c)(3) charity and all donations are tax deductible to the fullest extent
				allowed by law. You may view a copy of our annual financial statements and federal tax
				returns through links on our Financials page, or you can obtain them by writing
				to <a href="mailto:hello@pycfoundation.org">hello@pycfoundation.org</a>.
			</div>
			<div className={styles.paragraph}>
				By placing a donation with PYCGF you agree that:
				<ol>
					<li>
						Any donation you make is legal in your jurisdiction;
					</li>
					<li>
						PYCGF cannot be responsible for the success of any proposed or funded
						fundraiser or for the activities (or lack thereof) of the Fundraisers;
					</li>
					<li>
						We may, but are not obligated to, share information with you regarding each
						fundraiser. This may include descriptions of the proposed activity, photographs of
						the completed fundraiser, and thank-you notes. This Site Content and others we
						may send are solely for your personal, non-commercial use and may not be
						distributed, displayed, or copied unless expressly authorized by PYCGF;
					</li>
				</ol>
			</div>
			<div className={styles.subheader}>
				Third Party Websites
			</div>
			<div className={styles.italicParagraph}>
				This section describes how PYCGF links to websites, and what that means for you.
			</div>
			<div className={styles.paragraph}>
				The Sites may provide links to other websites (“Linked Sites”) as a convenience to you.
				Such Linked Sites are not maintained by PYCGF, thus PYCGF is not responsible for the
				content, products, services, policies, or activities of those Linked Sites. The inclusion of
				any link to such Linked Sites does not imply endorsement by PYCGF of the Linked
				Sites.
			</div>
			<div className={styles.subheader}>
				Disclaimers
			</div>
			<div className={styles.italicParagraph}>
				This section describes how the use of the Sites is at your own risk, and that PYCGF
				makes no warranties of any kind.
			</div>
			<div className={styles.subheader}>
				You expressly understand and agree that your use of the Sites, including the Site
				Content and resources and experiences funded through use of PYCGF, is at your
				sole risk. The Site and all Site Content are provided on an “as is” and “as
				available” basis, without warranty of any kind. PYCGF hereby expressly disclaims
				all warranties and conditions with regard to this Site and the Site Content,
				including without limitation, all express or implied warranties and conditions of
				merchantability, fitness for a particular purpose, title, and non-infringement.
			</div>
			<div className={styles.subheader}>
				PYCGF makes no warranty that: (i) this Site and its Site Content: are accurate,
				complete, timely, continually available, uninterrupted, virus-free, or error-free; (ii)
				the results that may be obtained from the use of the Site or its Site Content will be
				reliable; (iii) any errors in the Site Content will be corrected; and (iv) the Site or
				the service that makes it available are free of viruses or other harmful
				components or free of any breach of security (including data breach). In addition,
				we make no representation about the suitability of the Site Content for any
				purpose. You (and not PYCGF) assume the entire cost and risk of using this Site
				and its Site Content. PYCGF retains the right to restrict use of the Sites, in any
				manner it deems appropriate.
			</div>
			<div className={styles.subheader}>
				Limitation of Liability
			</div>
			<div className={styles.italicParagraph}>
				This section explains how we are not liable for any damages resulting from your use of
				our Sites.
			</div>
			<div className={styles.subheader}>
				In no event shall PYCGF, its agents, affiliates, licensors, and service providers,
				and, in each case, their directors, officers, representatives, employees,
				subcontractors, advisors, volunteers, or anyone else who has been involved in
				the creation, production, or delivery of the Sites and the Site Content contained
				thereon (collectively “PYCGF and its Affiliates") be liable for any damages
				whatsoever, including, without limitation: direct, indirect, punitive, incidental,
				special, consequential, or exemplary damages, damages for loss of products, use
				of data or other intangible losses resulting from the use of any of the Sites, the
				Site Content contained thereon, or any linked site, or with the delay or inability to
				use the Sites or the Site Content contained thereon, (including any failure of
				performance, error, omission, interruption, defect, delay in operation of
				transmission, computer virus, or equipment or network failure) whether based on
				contract, tort, strict liability, or otherwise, even if there is negligence by PYCGF
				and/or any authorized PYCGF representative or any person has been advised of
				the possibility of such damages.
			</div>
			<div className={styles.subheader}>
				You understand and agree that your use of the Sites is predicated upon your
				waiver of any right to sue PYCGF and its affiliates and to participate in any class
				action suit for any losses or damages resulting from your use of the Sites. Where
				applicable law does not permit the limitation of liability, implied warranties, or the
				exclusion or limitation of certain damages set forth above, the aggregate liability
				of PYCGF shall not exceed one hundred dollars ($100).
			</div>
			<div className={styles.subheader}>
				PYCGF has no control over the conduct of or any information provided by
				Donors, Fundraisers, or any user(s), and hereby disclaims all liability in this
				regard to the fullest extent permitted by applicable law, including, but not limited
				to, any errors or omissions in the User Content, for any loss of any kind incurred
				as a result of the use of any such User Content.
			</div>
			<div className={styles.subheader}>
				Termination
			</div>
			<div className={styles.italicParagraph}>
				This section describes how this Agreement can be terminated by you or PYCGF, and
				what you agree to when that happens.
			</div>
			<div className={styles.paragraph}>
				You may terminate this Agreement by contacting us to cancel your Donor or Fundraiser
				account, as applicable, and stopping all use of the Sites.
			</div>
			<div className={styles.paragraph}>
				PYCGF may take any action against you that we deem necessary or appropriate if we
				believe that you are violating the Terms, infringing any intellectual property right or other
				right of any person or entity, violating any law, or creating liability for PYCGF. We will
				take all appropriate legal action, including, without limitation, referral to law
				enforcement. We may also terminate, suspend, or limit your access to all or part of the
				Site and the Site Content for any or no reasons, including, without limitation, any
				violation of this Agreement, in our sole judgment, and without warning or prior notice.
			</div>
			<div className={styles.subheader}>
				Severability and Construction
			</div>
			<div className={styles.paragraph}>
				If any provision of this Agreement is unlawful, void, or unenforceable, the remaining
				provisions will remain in effect. The section headings are for convenience only and do
				not have any force or effect.
			</div>
			<div className={styles.subheader}>
				Resolution of Disputes & Governing Law
			</div>
			<div className={styles.paragraph}>
				This Agreement contains a binding arbitration provision which may be enforced by the parties.
			</div>
			<div className={styles.paragraph}>
				Any controversy or claim arising out of or relating to your use of any Site or this
				Agreement must be brought within one (1) year after the cause of action arises, or such
				claim or clause of action is barred, and shall be settled by binding arbitration in
				accordance with the commercial arbitration rules of the American Arbitration Association
				to be heard and adjudicated by one arbitrator to be mutually chosen by you and
				PYCGF. Any such controversy or claim shall be arbitrated on an individual basis, and
				shall not be consolidated in any arbitration with any claim or controversy of any other
				party.
			</div>
			<div className={styles.paragraph}>
				Any dispute, controversy, or claim arising out of or related to this Agreement or the Site
				is governed by the laws of the State of New York, USA and controlling United States
				federal law (excluding any rules of law that would lead to the application of the laws of
				any other jurisdiction and without application of the Uniform Computer Information
				Transaction Act or the United Nations Convention of Controls for International Sale of
				Goods). Any non-arbitrable claims must be brought in the state or federal courts of New
				York.
			</div>
			<div className={styles.paragraph}>
				You agree to submit to the jurisdiction of the state and federal courts in New York
				County in the State of New York with respect to such any litigation arising out of or
				related to your use of this Site or with respect to these Terms, waiving all affirmative and
				legal defenses regarding jurisdiction, forum, and venue.
			</div>
			<div className={styles.paragraph}>
				The arbitration shall be conducted in New York, New York, and claims regarding the
				judgment of the arbitrator (including entry of judgment on the arbitration award) shall be
				brought in and subject to the exclusive jurisdiction of the State and federal courts
				located in New York, New York, and you waive all affirmative and legal defenses in
				respect to any jurisdictional, venue, or inconvenient forum objections. Either you or
				PYCGF may seek any interim or preliminary relief from a state or federal court of
				competent jurisdiction in New York, New York, as may be necessary to protect the rights
				or property of you or PYCGF pending the completion of arbitration.
			</div>
			<div className={styles.subheader}>
				Indemnification
			</div>
			<div className={styles.paragraph}>
				You agree to indemnify, defend, and hold PYCGF and its Affiliates harmless from and
				against any and all loss, liability, claims, causes, actions, damages, or penalties
				including reasonable attorneys' fees incurred in connection with any claim made by any
				third party due to or arising out of the following:
				<ol>
					<li>
						Your use of any Site or Site Content in violation of any term of this Agreement or
						any applicable law or regulation;
					</li>
					<li>
						Breach of your representations and warranties as set forth in these Terms;
					</li>
					<li>
						Any User Content you provide to PYCGF or the Site;
					</li>
					<li>
						Any technical, security, or other disruption to the Site or systems transmitting the
						Site to you to the extent such disruption is related to your actions; or
					</li>
					<li>
						Any action taken by us during or as a result of any investigation by us into you.
					</li>
				</ol>
			</div>
			<div className={styles.paragraph}>
				You agree that you’ll cooperate with us in the defense of any claim. We reserve the
				right, at our own expense, to assume the exclusive defense and control of any matter
				subject to indemnification by you.
			</div>
			<div className={styles.subheader}>
				Contact PYCGF
			</div>
			<div className={styles.paragraph}>
				If you have any questions about the Sites or this Agreement, you may contact us via e-
				mail at <a href="mailto:hello@pycfoundation.org">hello@pycfoundation.org</a>.
			</div>
			<div className={styles.subheader}>
				Entire Agreement
			</div>
			<div className={styles.paragraph}>
				This Agreement, including the terms specifically applicable to Donors and Fundraisers,
				and other policies and notices PYCGF may post on the Sites, constitute the entire
				agreement between PYCGF and you in connection with your use of the Sites and
				supersedes any prior agreements between PYCGF and you regarding such matters,
				including prior versions of this Agreement. The terms of this Agreement are effective
				until terminated. In the event of termination, the disclaimers, limitations of liabilities, and
				indemnities set forth in this Agreement will survive.
			</div>
		</div>
	)
};

export default Terms;